import Head from 'next/head';
import { useEffect, useState, type ReactElement } from 'react';
import { supabase } from '../lib/supabaseClient';
import { HeroSection } from '@/components/home/hero-section';
import { FeaturesSection } from '@/components/home/features-section';
import { TrustSection } from '@/components/home/trust-section';

export default function Home(): ReactElement {
  const [user, setUser] = useState<unknown | null>(null);

  useEffect((): (() => void) => {
    const run = async (): Promise<void> => {
      const { data } = await supabase.auth.getSession();
      setUser(data?.session?.user ?? null);
    };
    void run();
    const { data: listener } = supabase.auth.onAuthStateChange((_e, session) => setUser(session?.user ?? null));
    return () => listener.subscription.unsubscribe();
  }, []);

  return (
    <>
      <Head>
        <title>KEM Discovery - Discover Your Key Emotional Motivators</title>
        <meta name="description" content="Discover what truly drives you with our science-backed Key Emotional Motivators assessment. Understand your deepest motivations and unlock your potential." />
        <meta name="keywords" content="emotional intelligence, motivation, self-discovery, psychology, assessment" />
      </Head>
      
      <HeroSection isAuthenticated={!!user} showAccessCards={!user} />

      <FeaturesSection />

      <TrustSection />
    </>
  );
}

